import React, { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { RefHandle } from "../../../shared/RefHandle";
import { TInputValue } from "../../ui/Input/Input";
import InputContextProvider, { EInputUpdateAction } from "../../ui/Input/input-context";
import IExtra from "../../../shared/IExtra";
import Extra from "./Extra";
import Table from "../../ui/Table/Table";

interface IProps {
  extras: IExtra[];
  setExtras: React.Dispatch<React.SetStateAction<IExtra[]>>;
  currency: string;
}

const Extras: React.ForwardRefRenderFunction<RefHandle<IExtra[]>, IProps> = ({
  extras,
  setExtras,
  currency
}, ref) => {

  const autoUpdateHandler = useCallback(
    async (inputName: string, value: TInputValue, action: string, _: any) => {
      if (action === EInputUpdateAction.EXTRA) {
        // console.log(inputName, value, action, _);
        const data = _ as IExtra;
        setExtras((rows) =>
          rows.map((row) =>
            row.code === data.code
              ? { ...row, ...data, [inputName]: value }
              : row
          )
        );
      }
      return Promise.resolve(true);
    },
    [setExtras]
  );

  const extrasRef = useRef<RefHandle<IExtra>[]>([]);

  const getData = useCallback(async () => {
    const rows = extrasRef.current;
    const newRows: IExtra[] = [];
    if (rows?.length > 0) {
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        if (row) {
          const rowData = await row.getData();
          if (rowData) {
            newRows.push(rowData);
          }
        }
      }
    }
    return newRows;
  }, []);

  useImperativeHandle(ref, () => ({ getData }));

  return (
    <Table condensed>
      <tbody>
        <InputContextProvider initDone onAutoUpdate={autoUpdateHandler}>
          {extras.map((extra, i) => (
            <Extra
              key={extra.code}
              extra={extra}
              currency={currency}
              ref={(rowHandle) => {(extrasRef.current[i] = rowHandle!)}}
            />
          ))}
        </InputContextProvider>
      </tbody>
    </Table>
  );
};

export default forwardRef(Extras);
